<template>
  <div class="container__program program">
    <div class="program__inner">
      <h2 class="program__title">Программа</h2>
      <div class="program__steps">
        <div
          class="program__step"
          v-for="({ time, text }, index) in steps"
          :key="index"
        >
          <div class="program__step-time">{{ time }}</div>
          <span></span>
          <div class="program__step-text">{{ text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Program",
  data: () => ({
    steps: [
      {
        time: "10:00",
        text:
          "Приветствие Лии Сергеевой, основателя реабилитационного центра «Серафим». Житие св. Серафима Саровского – рассказывает Священник Максим Горожанкин"
      },
      {
        time: "11:00",
        text:
          "«Дивное Дивеево» - документальный фильм режиссера Андрея Холенко (единственный режиссер, которому было дано благословение снимать в Дивеевском монтастыре)."
      },
      {
        time: "12:00",
        text:
          'Секреты русской кухни: мастер-класс по приготовлению запеченных яблок на меду и курицы с розмарином от Олега Ольхова, шеф-повара Даниловского монастыря, ведущего рубрики "Быстрый завтрак" передачи "Утро на Спасе" (Телеканал Спас), владельца кулинарной студии "Кремлëвская Кухня" в Измайловском Кремле.'
      },
      {
        time: "13:00",
        text:
          "Библиотерапия – работа со страхами, внутренними переживаниями и проблемами ребенка через литературные произведения. О технике и принципах на примере пушкинских произведений рассказывает Татьяна Кондратьева, кандидат филологических наук, ректор Православного гуманитарного института «Со-действие», автор курса по библиотерапии, мама 4х детей."
      },
      {
        time: "14:00",
        text:
          "Интервью с педиатором с 28 летнем стажем, сертифицированным системным врачом-натуропатом Ольгой Мамыкиной о том, что делать с самого 1 года жизни, чтобы вырастить здорового ребенка"
      },
      {
        time: "15:00",
        text:
          "Монтессори-педагогика: как играючи научить ребенка думать, читать, считать и как развить память – материалы от Софьи Сумнительной, руководителя Центра Монтессори"
      },
      {
        time: "16:00",
        text:
          "Основные правила самостоятельного массажа ребенку, работа с опорно-двигательной системой от врача-реабилитолога Тариеля Лобджанидзе"
      },
      {
        time: "17:00",
        text:
          "Серафим и Грузия – статья Мариам Сараджишвили Интервью с отцом Алексеем Костиным о будущем Храме имени Серафима Саровского в Грузии в п. Уреки, рядом с реабилитационным центром «Серафим»"
      }
    ]
  })
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.program {
  &__steps {
    overflow-y: auto;
    max-height: 400px;

    &::-webkit-scrollbar {
      width: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $aux_bg;
    }
  }

  &__step {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 0 20px;

    &-time {
      font-weight: $bl_fw;
      text-align: center;
    }

    &-time,
    &-text {
      position: relative;
      line-height: 1.2;
    }

    span {
      position: absolute;
      display: block;
      top: 0;
      border: 2px solid $aux_bg;
      border-radius: 50%;
    }

    &:not(:last-child)::before {
      position: absolute;
      background-color: $aux_bg;
      content: "";
    }

    @media screen and (min-width: $min-lg) {
      &-time {
        width: 35%;
        font-size: 20px;
      }

      &-text {
        width: 75%;
      }

      &-time,
      &-text {
        padding: 0 10px;
      }

      span,
      &::before {
        transform: translateX(-100%);
      }

      span {
        left: calc(50% - 100px);
        width: 18px;
        height: 18px;
      }

      &::before {
        top: 18px;
        left: calc(50% - 108px);
        width: 2px;
        height: calc(100% - 18px);
      }
    }

    @media screen and (max-width: $max-md) {
      &-time {
        padding: 0 10px;
        font-size: 18px;
      }

      &-text {
        margin: 0 0 0 10px;
      }

      span,
      &::before {
        display: none;
      }
    }
  }
}
</style>
